import RenderInput from './RenderInput';

export default RenderInput;
